.language-switcher {
  display: flex;
  align-items: center;
  position: relative;
  width: 100%;
  height: 40px;
  line-height: 16px;
  font-size: $font-size-base;
  color: var(--color-neutral-black);
  background: var(--color-neutral-white);
  border-radius: 4px;
  appearance: none;
  user-select: none;
  cursor: pointer;
  text-align: left;
  z-index: 39;
  overflow: visible;

  @include desktop-md {
    margin: 28px 0 0;
    height: 48px;
  }

  &::after {
    position: absolute;
    content: '';
    background-image: url('data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iOCIgaGVpZ2h0PSI1IiB2aWV3Qm94PSIwIDAgOCA1IiBmaWxsPSJub25lIiB4bWxucz0iaHR0cDovL3d3dy53My5vcmcvMjAwMC9zdmciPgo8cGF0aCBmaWxsLXJ1bGU9ImV2ZW5vZGQiIGNsaXAtcnVsZT0iZXZlbm9kZCIgZD0iTTAuMjkyODkzIDAuMjkyODkzQy0wLjA5NzYzMTEgMC42ODM0MTggLTAuMDk3NjMxMSAxLjMxNjU4IDAuMjkyODkzIDEuNzA3MTFMMy4yOTI4OSA0LjcwNzExQzMuNjgzNDIgNS4wOTc2MyA0LjMxNjU4IDUuMDk3NjMgNC43MDcxMSA0LjcwNzExTDcuNzA3MTEgMS43MDcxMUM4LjA5NzYzIDEuMzE2NTggOC4wOTc2MyAwLjY4MzQxOCA3LjcwNzExIDAuMjkyODkzQzcuMzE2NTggLTAuMDk3NjMxMSA2LjY4MzQyIC0wLjA5NzYzMTEgNi4yOTI4OSAwLjI5Mjg5M0w0IDIuNTg1NzlMMS43MDcxMSAwLjI5Mjg5M0MxLjMxNjU4IC0wLjA5NzYzMTEgMC42ODM0MTggLTAuMDk3NjMxMSAwLjI5Mjg5MyAwLjI5Mjg5M1oiIGZpbGw9IiM0MTQxNDEiLz4KPC9zdmc+Cg==');
    background-repeat: no-repeat;
    background-size: contain;
    width: 8px;
    height: 5px;
    right: 15px;
    transition: transform 0.2s;
    background-position: center;
    transform: translateY(-50%);
    transform-origin: center center;
    top: 50%;
  }

  .language-dropdown__list {
    display: block;
    margin: 0;
    padding: var(--spacing-xs) 0;
  }

  .language-dropdown__list-wrap {
    position: absolute;
    left: 0;
    right: 0;
    background: var(--background-color-primary);
    border: var(--border-size-sm) solid var(--border-color-secondary);
    border-radius: var(--radius-size-sm);
    box-shadow: 0 2px 4px rgb(47 55 62 / 15%);
    z-index: 3;
    max-height: 240px;
    overflow-y: auto;
    margin: 0;
    opacity: 0;
    visibility: hidden;
    pointer-events: none;
    transform: translateY(-10px);
    transition:
      opacity 0.2s ease,
      visibility 0s linear 0.2s,
      transform 0.2s ease;
    -webkit-overflow-scrolling: touch;
  }

  &.is-open {
    .language-switcher__label {
      outline: none;
      overflow: visible;
      box-shadow:
        0 0 0 var(--border-size-md) var(--color-neutral-white),
        0 0 0 var(--border-size-lg) var(--color-brand-primary-light);
    }

    &::after {
      transform: translateY(-50%) rotate(180deg);
    }

    .language-dropdown__list-wrap {
      opacity: 1;
      visibility: visible;
      pointer-events: auto;
      transition-delay: 0s;
      transform: translateY(0);
    }

    &.language-switcher--top {
      .language-dropdown__list-wrap {
        border-radius: var(--radius-size-sm) var(--radius-size-sm) 0 0;
        border-top: var(--border-size-sm) solid var(--border-color-secondary);
        border-bottom: none;

        // Position is set via inline styles in calculateDropdownPosition
      }
    }

    &.language-switcher--bottom {
      .language-dropdown__list-wrap {
        border-radius: 0 0 var(--radius-size-sm) var(--radius-size-sm);
        border-top: var(--border-size-sm) solid var(--border-color-secondary);
        border-bottom: none;

        // Position is set via inline styles in calculateDropdownPosition
      }
    }
  }

  .language-switcher__label {
    display: flex;
    padding-right: 50px;
    color: var(--color-neutral-black);
    white-space: nowrap;
    overflow: hidden;
    border: 1px solid var(--color-neutral-black);
    text-overflow: ellipsis;
    position: relative;
    border-radius: 4px;
    z-index: 2;
    height: 40px;
    align-items: center;
    max-width: 192px;
    flex-shrink: 0;
    left: -1px;
    font-size: $font-size-base;
    line-height: 24px;
    padding-left: 35px;
    transition: all 0.2s ease-in-out;

    @include desktop-md {
      font-size: 16px;
      line-height: 24px;
      height: 48px;
    }

    &:focus {
      outline: none;
    }

    &:focus-visible {
      outline: none;
      overflow: visible;
      box-shadow:
        0 0 0 var(--border-size-md) var(--color-neutral-white),
        0 0 0 var(--border-size-lg) var(--color-brand-primary-light);
    }

    &::before {
      position: absolute;
      content: '';
      top: 0;
      bottom: 0;
      margin: auto;
      left: 11px;
      width: 18px;
      height: 18px;
      background: url('data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMTgiIGhlaWdodD0iMTgiIHZpZXdCb3g9IjAgMCAxOCAxOCIgZmlsbD0ibm9uZSIgeG1sbnM9Imh0dHA6Ly93d3cudzMub3JnLzIwMDAvc3ZnIj4KPGNpcmNsZSBjeD0iOSIgY3k9IjkiIHI9IjgiIHN0cm9rZT0iIzQxNDE0MSIgc3Ryb2tlLXdpZHRoPSIxLjUiLz4KPGVsbGlwc2UgY3g9IjkuMDAwMTQiIGN5PSI5IiByeD0iMy41NTU1NiIgcnk9IjgiIHN0cm9rZT0iIzQxNDE0MSIgc3Ryb2tlLXdpZHRoPSIxLjUiLz4KPGxpbmUgeDE9IjEiIHkxPSIxMS44MDUyIiB4Mj0iMTYuMTExMSIgeTI9IjExLjgwNTIiIHN0cm9rZT0iIzQxNDE0MSIgc3Ryb2tlLXdpZHRoPSIxLjUiLz4KPGxpbmUgeDE9IjEiIHkxPSI2LjQ3MjE3IiB4Mj0iMTYuMTExMSIgeTI9IjYuNDcyMTciIHN0cm9rZT0iIzQxNDE0MSIgc3Ryb2tlLXdpZHRoPSIxLjUiLz4KPC9zdmc+Cg==')
        no-repeat;
      background-size: contain;
    }
  }

  .language-dropdown__option {
    background: none;
    border: none;
    color: var(--text-color-primary);
    cursor: pointer;
    display: block;
    font-family: inherit;
    font-size: map-get($font-sizes, sm);
    font-weight: map-get($font-weights, normal);
    line-height: var(--spacing-md);
    margin: 0;
    overflow: hidden;
    padding: var(--spacing-sm) var(--spacing-md);
    position: relative;
    text-align: left;
    text-decoration: none;
    text-overflow: ellipsis;
    width: 100%;
    white-space: nowrap;

    &:hover {
      background: var(--color-neutral-neutral-lighter);
      text-decoration: none;
    }

    &:focus {
      outline: none;
    }
  }

  .language-dropdown__option--active {
    color: var(--text-color-primary);
    font-weight: map-get($font-weights, semi-bold);
    position: relative;
  }

  .language-dropdown__option--focused {
    background: var(--color-neutral-neutral-lighter);
    outline: none;
  }
}
